import React, { Component } from "react";
import { Row, Col, Card } from "reactstrap";
import PersonalDetails from "./personal_details/PersonalDetails";
import EducationalDetails from "./educational_details/educationdetail";
import ContactDetailsMain from "./contact_details/ContactDetailsMain";
import ProfessionalDetail from "./proffesional_details/professional_details";
import Projectdetail from "./project_details/project_details";
import HonoursAwards from "./honours_awards/honours";
import Certificates from "./certificates/certificatesdetail";
import '../../assets/css/responsive.css'

import axios from "axios";
import { API_CANDIDATE } from "../../utils/config";
import { withRouter } from "react-router-dom";
import UploadDocument from "./upload_documents/documents";
import CareerObjective from "./careerObjective/careersObjective";
import Expirence from "./ExpirenceSummary/expirenceSummary";
import Extra from "./extraCricular/extraCurri";
import Technical from "./technicalSkills/technical";
import { FaUserGraduate } from "react-icons/fa";
import { FaIdBadge } from "react-icons/fa";
import { RiChatUploadFill } from "react-icons/ri";
import { AiTwotoneSafetyCertificate } from "react-icons/ai";
import { MdGames } from "react-icons/md";
import { FaUserCheck } from "react-icons/fa";
import { FaUserCog } from "react-icons/fa";
import { FaUserShield } from "react-icons/fa";
import { FaSkiingNordic } from "react-icons/fa";
import { FaAward } from "react-icons/fa";
// import { useHistory } from "react-router-dom";



/**
 * MyProfile Component for rendering all the profile components.
 */
class MyProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: "",
      data: "",
      captilize: "",
    };

    this.back = this.back.bind(this);
    this.chooseForm = this.chooseForm.bind(this);
  }

 
  back() {
    this.setState({
      edit: "",
    });
  }

  componentDidMount() {
    this.getData();
  }

  getData() {
    axios
      .get(`${API_CANDIDATE}/v1/api/create-user`, { withCredentials: true })
      .then((res) => {
        console.log(res);

        if (res.data.ok === false) {
          this.props.history.push("/validateuser");
        }

        this.setState({
          data: res.data.firstName,
        });
      })
      .catch((err) => {
        console.log("err", err);
      });
  }

  /*
chooseForm function to select the particular tab related view should display
*/
  chooseForm() {
    let component = this.state.edit;

    if (component === "personal") {
      return <PersonalDetails back={this.back} />;
    }
    if (component === "contact") {
      return <ContactDetailsMain back={this.back} />;
    }
    if (component === "HonoursAwards") {
      return <HonoursAwards back={this.back} />;
    }

    if (component === "projectdetail") {
      return <Projectdetail back={this.back} />;
    }

    if (component === "professional") {
      return <ProfessionalDetail back={this.back} />;
    }

    if (component === "education") {
      return <EducationalDetails back={this.back} />;
    }

    if (component === "certificates") {
      return <Certificates back={this.back} />;
    }
    if (component === "uploaddocuments") {
      return <UploadDocument back={this.back} />;
    }
    if (component === "career") {
      return <CareerObjective back={this.back} />;
    }
    if (component === "extra") {
      return <Extra back={this.back} />;
    }
    if (component === "Expirence") {
      return <Expirence back={this.back} />;
    }

    if (component === "technical") {
      return <Technical back={this.back} />;
    }
  }

  render() {
   

    return (
      <div className='profile-div'>
        {!this.state.edit ? (
          <div style={{ alignItems: "center", marginTop: "45px" }}>
         
            <div
              style={{
                background: "#005500",
                height: "60px",
                alignItems: "center",
                display: "flex",
                justifyContent: "center",
              }}
              
              id="welcome-div"
            >
              <p id="welcome-p">
                WELCOME <span id="captial-first">{this.state.data&&this.state.data.toUpperCase()}</span>
              </p>
            </div>
         
          
            <div id="myprofile-category-div">
        
              <Row>
                <Col md="6">
                  <Card
                   
                    className="myprofile-card"
                    onClick={() => this.setState({ edit: "personal" })}
                  >
                    <i className="material-icons">person</i>
                    Personal Details
                  </Card>
                </Col>
                <Col md="6">
                  <Card
                  
                    className="myprofile-card"
                    onClick={() => this.setState({ edit: "contact" })}
                  >
                    <i className="material-icons">contacts</i>
                    Contact Details
                  </Card>
                </Col>
                <Col style={{ marginTop: "-0.6rem" }} md="6">
                  <Card
                 
                    className="myprofile-card"
                    onClick={() => this.setState({ edit: "career" })}
                  >
                    <h1 style={{ marginTop: "-0.4rem", fontSize: "1.3rem" }}>
                      <FaUserGraduate />
                    </h1>
                    Career Objectives
                  </Card>
                </Col>
                <Col style={{ marginTop: "-0.6rem" }} md="6">
                  <Card
                  
                    className="myprofile-card"
                    onClick={() => this.setState({ edit: "Expirence" })}
                  >
                    <h1 style={{ marginTop: "-0.4rem", fontSize: "1.3rem" }}>
                      <FaIdBadge />
                    </h1>
                    Experience Summary
                  </Card>
                </Col>

                <Col style={{ marginTop: "-0.6rem" }} md="6">
                  <Card
                 
                    className="myprofile-card"
                    onClick={() => this.setState({ edit: "professional" })}
                  >
                    <h1 style={{ marginTop: "-0.4rem", fontSize: "1.3rem" }}>
                      <FaUserCog />
                    </h1>
                    Professional Experience
                  </Card>
                </Col>
                <Col style={{ marginTop: "-0.6rem" }} md="6">
                  <Card
                 
                    className="myprofile-card"
                    onClick={() => this.setState({ edit: "technical" })}
                  >
                    <h1 style={{ marginTop: "-0.4rem", fontSize: "1.3rem" }}>
                      <FaUserCheck />
                    </h1>
                     Skills
                  </Card>
                </Col>
                <Col style={{ marginTop: "-0.6rem" }} md="6">
                  <Card
                   
                    className="myprofile-card"
                    onClick={() => this.setState({ edit: "education" })}
                  >
                    <h1 style={{ marginTop: "-0.4rem", fontSize: "1.3rem" }}>
                      <FaUserShield />
                    </h1>
                    Academic Details
                  </Card>
                </Col>

                <Col style={{ marginTop: "-0.6rem" }} md="6">
                  <Card
                
                    className="myprofile-card"
                    onClick={() => this.setState({ edit: "certificates" })}
                  >
                    <h1 style={{ marginTop: "-0.4rem", fontSize: "1.3rem" }}>
                      <FaSkiingNordic />
                    </h1>
                    Trainings & Certifications
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col style={{ marginTop: "-0.6rem" }} md="6">
                  <Card
                  
                    className="myprofile-card"
                    onClick={() => this.setState({ edit: "projectdetail" })}
                  >
                    <h1 style={{ marginTop: "-0.4rem", fontSize: "1.3rem" }}>
                      <AiTwotoneSafetyCertificate />
                    </h1>
                    Project Details
                  </Card>
                </Col>

                <Col style={{ marginTop: "-0.6rem" }} md="6">
                  <Card
                  
                    className="myprofile-card"
                    onClick={() => this.setState({ edit: "HonoursAwards" })}
                  >
                    <h1 style={{ marginTop: "-0.4rem", fontSize: "1.3rem" }}>
                      <FaAward />
                    </h1>
                    Honors and Awards
                  </Card>
                </Col>

                <Col style={{ marginTop: "-0.6rem" }} md="6">
                  <Card
                 
                    className="myprofile-card"
                    onClick={() => this.setState({ edit: "extra" })}
                  >
                    <h1 style={{ marginTop: "-0.4rem", fontSize: "1.3rem" }}>
                      <MdGames />
                    </h1>
                    Extracurricular Activities
                  </Card>
                </Col>

                <Col style={{ marginTop: "-0.6rem" }} md="6">
                  <Card
                
                    className="myprofile-card"
                    onClick={() => this.setState({ edit: "uploaddocuments" })}
                  >
                    <h1 style={{ marginTop: "-0.4rem", fontSize: "1.3rem" }}>
                      <RiChatUploadFill />
                    </h1>
                    Upload Documents
                  </Card>
                </Col>
              </Row>
            </div>
            </div>
        
        ) : (
          this.chooseForm()
        )}
      </div>
    );
  }
}

export default withRouter(MyProfile);
